// Pure formatting for a rate's applicability, so a value the backend ASSUMED
// (column default, never stated by the source or curator) is never worded as
// an observation. Evidence keys mirror delivery_rate_observations_repository.go.
const RATE_UNIT_ASSUMED_KEY = 'rate_unit_assumption';
const CURRENCY_ASSUMED_KEY = 'currency_assumption';
const evidenceHasKey = (evidenceJson, key)=>{
    if (!evidenceJson) return false;
    try {
        const obj = JSON.parse(evidenceJson);
        return !!obj && typeof obj === 'object' && !Array.isArray(obj) && key in obj;
    } catch  {
        return false;
    }
};
export const isRateUnitAssumed = (evidenceJson)=>evidenceHasKey(evidenceJson, RATE_UNIT_ASSUMED_KEY);
export const isCurrencyAssumed = (evidenceJson)=>evidenceHasKey(evidenceJson, CURRENCY_ASSUMED_KEY);
// One phrase per assumption, naming the value that was assumed.
export const rateAssumptionNotes = (r)=>{
    const notes = [];
    if (isRateUnitAssumed(r.evidenceJson)) {
        notes.push(`unit not stated, assumed ${(r.rateUnit || 'hourly').toLowerCase()}`);
    }
    if (isCurrencyAssumed(r.evidenceJson)) {
        notes.push(`currency not stated, assumed ${r.currency || 'USD'}`);
    }
    return notes;
};
// Unknown dates are said to be unknown; a default would read as a real span.
export const periodDatesLabel = (r)=>{
    const day = (t)=>t && typeof t.toDate === 'function' ? t.toDate().toISOString().slice(0, 10) : '?';
    if (!r.periodStart && !r.periodEnd) return 'period dates unknown';
    return `${day(r.periodStart)} to ${day(r.periodEnd)}`;
};
